var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementsIconEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A2ABB5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25c.816.014 1.99-1.027 2.58-1.455 4.666-3.386 5.02-3.681 6.097-4.525.203-.158.323-.404.323-.665v-.667c0-.932-.756-1.688-1.688-1.688H4.688C3.756 5.25 3 6.006 3 6.938v.667c0 .26.12.503.323.665 1.076.84 1.431 1.139 6.097 4.525.59.428 1.764 1.47 2.58 1.455zm7.312 4.5c.932 0 1.688-.756 1.688-1.688V9.873c0-.172-.204-.274-.341-.165-.788.612-1.828 1.392-5.414 3.997-.714.52-1.99 1.684-3.245 1.673-1.248.008-2.5-1.132-3.241-1.673-3.586-2.605-4.63-3.382-5.418-3.994-.14-.109-.341-.01-.341.166v7.185c0 .932.756 1.688 1.688 1.688h14.624z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementsIconEmail);
export default __webpack_public_path__ + "static/media/elements-icon-email.39358a44d15cc5678eafff35dfdee445.svg";
export { ForwardRef as ReactComponent };